import React from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { Home } from './pages/Home';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="35bsfgyjqj8tr">
      <Home data-id="element-1" data-mp="35eepr5y0g2fo" />
    </LanguageProvider>;
}